// Detects "the browser asked for a JS chunk that no longer exists" failures
// (deploy skew: a long-lived tab holding pre-deploy HTML fetches a hashed
// chunk the new deployment doesn't serve) and cures the page with ONE
// automatic reload — fresh HTML references the current deployment's chunks.
// The sessionStorage guard makes a reload loop impossible: if the reload
// didn't fix it (a real network failure), we never reload again this session
// and the error just gets reported as usual.

const RELOAD_GUARD_KEY = 'ht_chunk_reloaded'

// Fixed message shapes emitted by chunk loaders — never by app code:
// Turbopack runtime, webpack runtime, Safari's and Firefox's native dynamic
// import failures.
const CHUNK_ERROR =
  /Failed to load chunk|Loading chunk \S+ failed|Importing a module script failed|error loading dynamically imported module/i

export const isChunkLoadError = (message: string): boolean => CHUNK_ERROR.test(message)

export const maybeReloadForChunkError = (message: string): void => {
  if (!isChunkLoadError(message)) {
    return
  }
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY)) {
      return
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, new Date().toISOString())
  } catch {
    // Storage unavailable (privacy mode/quota) — without the guard a reload
    // loop is possible, so never reload at all.
    return
  }
  // A beat of delay so the error beacon for this event is handed to
  // sendBeacon (which survives navigation) before the page goes away.
  setTimeout(() => window.location.reload(), 50)
}
